import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ConfigError } from '../../util/Errors.js';
import { FORMS } from '../ion/RemediationConstants.js';
import { CONFIGURED_FLOW } from './constants.js';
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
// checks if "desired" remeidation is available before calling `.proceed`
// if not available, returns original idxResponse (and logs warning)

function proceedIfAvailable(_x, _x2, _x3) {
  return _proceedIfAvailable.apply(this, arguments);
} // attempts to "step into" a specific flow by calling `.proceed` with a specific remeidation (or calls an action)
// the "desired" remeidation is not guaranteed to be available, depends upon Org configurations


function _proceedIfAvailable() {
  _proceedIfAvailable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(idxState, remediation, flow) {
    var rem, nextIdxState;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rem = idxState.neededToProceed.find(function (item) {
              return item.name === remediation;
            });

            if (rem) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", idxState);

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return idxState.proceed(remediation);

          case 6:
            nextIdxState = _context.sent;
            return _context.abrupt("return", nextIdxState);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](3);

            if (!(typeof _context.t0 === 'string' && _context.t0.startsWith('Unknown remediation choice'))) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", idxState);

          case 16:
            throw _context.t0;

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _proceedIfAvailable.apply(this, arguments);
}

function stepIntoSpecificIdxFlow(_x4) {
  return _stepIntoSpecificIdxFlow.apply(this, arguments);
} // ensures the `flow` stored in the transaction meta matches the flow configuration
// if they do not match, abandon the current (meta) flow and start a new (configured) flow


function _stepIntoSpecificIdxFlow() {
  _stepIntoSpecificIdxFlow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(idxState) {
    var flow,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            flow = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'default';
            _context2.t0 = flow;
            _context2.next = _context2.t0 === CONFIGURED_FLOW.DEFAULT ? 4 : _context2.t0 === CONFIGURED_FLOW.PROCEED ? 4 : _context2.t0 === CONFIGURED_FLOW.LOGIN ? 4 : _context2.t0 === CONFIGURED_FLOW.REGISTRATION ? 5 : _context2.t0 === CONFIGURED_FLOW.RESET_PASSWORD ? 5 : _context2.t0 === CONFIGURED_FLOW.UNLOCK_ACCOUNT ? 6 : 9;
            break;

          case 4:
            return _context2.abrupt("return", idxState);

          case 5:
            return _context2.abrupt("return", idxState);

          case 6:
            _context2.next = 8;
            return proceedIfAvailable(idxState, FORMS.UNLOCK_ACCOUNT);

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 9:
            throw new ConfigError('Invalid "flow" configuration');

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _stepIntoSpecificIdxFlow.apply(this, arguments);
}

function handleConfiguredFlow(_x5, _x6) {
  return _handleConfiguredFlow.apply(this, arguments);
}

function _handleConfiguredFlow() {
  _handleConfiguredFlow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(originalResp, settings) {
    var authClient, configuredFlow, idxState;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            authClient = settings.getAuthClient();
            configuredFlow = authClient.idx.getFlow(); // attempts to step into the desired flow

            _context3.next = 4;
            return stepIntoSpecificIdxFlow(originalResp, configuredFlow);

          case 4:
            idxState = _context3.sent;
            return _context3.abrupt("return", idxState);

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _handleConfiguredFlow.apply(this, arguments);
}

export { handleConfiguredFlow };